import classNames from 'classnames'
import { useState } from 'react'
import { useTranslation } from 'next-i18next'

import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'
import { ContainerHomGradientBorder } from '~/components/Containers'
import { StatisticsTabs } from '~/analytics/statistics/statisticsEvents.types'
import { ProfileCardTab } from '~/statistics/types/profile-card.types'
import LearningCard from '~/statistics/components/ProfileCards/LearningCard'
import RewardsCard from '~/statistics/components/ProfileCards/RewardsCard'
import { IUser } from '~/types/user-info-types'

export default function ProfileCard({ user }: { user?: IUser }): React.ReactElement {
  const { t } = useTranslation('statistics')
  const [currentTab, setCurrentTab] = useState(ProfileCardTab.LEARNING)

  const onChangeProfileTab = (selectedTab: ProfileCardTab): void => {
    statisticsAnalytics.logTabChange(StatisticsTabs.PROFILE_CARD, selectedTab)
    setCurrentTab(selectedTab)
  }

  const learningTabClassNames = classNames('outline-0 w-full pt-2 pb-3 rounded-t bg-white', {
    'leading-4 border-2 border-b-0 border-t-blue-logo border-l-blue-logo border-r-blue-logo border-b-none':
      currentTab === ProfileCardTab.LEARNING,
  })

  const rewardsTabClassNames = classNames('outline-0 w-full pt-2 pb-3 rounded-t bg-white', {
    'leading-4 border-2 border-b-0 border-t-blue-logo border-l-blue-logo border-r-blue-logo border-b-none':
      currentTab === ProfileCardTab.REWARDS,
  })

  const learningContentBoxStyle = {
    borderRadius: '10px / 0px 10px 10px 10px',
  }

  const rewardsContentBoxStyle = {
    borderRadius: '10px / 10px 0px 10px 10px',
  }

  const contentBoxStyle = currentTab === ProfileCardTab.LEARNING ? learningContentBoxStyle : rewardsContentBoxStyle

  return (
    <div className="w-full -mt-14 pt-10 lg:top-10 lg:left-0 lg:sticky">
      <div className="flex">
        <div className={`relative w-full ${currentTab === ProfileCardTab.LEARNING ? 'z-20' : ''}`}>
          <button
            className={learningTabClassNames}
            onClick={() => {
              onChangeProfileTab(ProfileCardTab.LEARNING)
            }}
          >
            {t('learning')}
          </button>
        </div>
        <div className={`relative w-full ${currentTab === ProfileCardTab.REWARDS ? 'z-20' : ''}`}>
          <button
            className={rewardsTabClassNames}
            onClick={() => {
              onChangeProfileTab(ProfileCardTab.REWARDS)
            }}
          >
            {t('rewards')}
          </button>
        </div>
      </div>
      <ContainerHomGradientBorder
        innerClassName="pb-2"
        innerStyle={contentBoxStyle}
        outerClassName="relative -mt-2 w-full z-10"
        outerStyle={{ ...contentBoxStyle }}
      >
        {currentTab === ProfileCardTab.LEARNING ? <LearningCard user={user} /> : <RewardsCard user={user} />}
      </ContainerHomGradientBorder>
    </div>
  )
}
